<template>
  <v-list dense>
    <template v-for="p in items.concat(blankItems).slice(0,5)">
      <v-divider></v-divider>
      <v-list-tile :key="p.dbid" @click="">
        <v-list-tile-content>
          <v-list-tile-title>{{p.name}}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-list-tile-action-text>{{p.count || '0'}}</v-list-tile-action-text>
        </v-list-tile-action>
      </v-list-tile>
    </template>
  </v-list>
</template>
<script>
  export default {
    props: ['uri'],

    data() {
      return {
        loading: false,
        blankItems: [
          {"dbid": "00000000001", "name": "", "count": null},
          {"dbid": "00000000002", "name": "", "count": null},
          {"dbid": "00000000003", "name": "", "count": null},
          {"dbid": "00000000004", "name": "", "count": null},
          {"dbid": "00000000005", "name": "", "count": null},
        ],

        items: []
      }
    },

    created() {
      this.get()
    },

    methods: {
      /**
       * **************************************************************
       * 异步数据请求
       */
      get() {
        if (this.uri.length === 0) return;

        const vm = this;
        this.loading = true;
        const param = Object.assign(
          {},
          window.xutil.param("note", this.note),
        );
        this.axios.get(this.uri, param)
          .then(rsp => {
            // 填充对话框
            vm.items = rsp.data;
            vm.loading = false;
          });
      }

    }
  }
</script>
<style scoped>
  div.card div.card__text {
    display: flex;
    font-size: 14px;
    margin: 4px auto;
    padding: 8px 15px;
    position: relative;
  }

  div.card div.card__text > div {
    -ms-flex-item-align: center;
    align-self: center;
    -webkit-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
    margin-left: 1em;
  }
</style>
